module.exports = __webpack_public_path__ + "img/img_category.9f0eb699.png";